import { normalizeChartingFavoriteFolders, normalizeChartingMutationResult } from '@/features/charting-next/adapters/chartingPreferenceAdapters';
import { buildChartingFavoriteFolderPayload, buildChartingFavoriteMembershipPayload } from '@/features/charting-next/adapters/chartingPayloads';
import { get, postForm } from '@/features/charting-next/api/chartingRepositoryClient';

export async function fetchChartingFavoriteFolders() {
    const payload = await get('/api/v1/stock-finder/favorite-folder/list');

    return normalizeChartingFavoriteFolders(payload);
}

export async function createChartingFavoriteFolder(input) {
    const payload = await postForm('/api/v1/stock-finder/favorite-folder/create', buildChartingFavoriteFolderPayload(input));

    return normalizeChartingMutationResult(payload, 'La carpeta de favoritos se ha creado.');
}

export async function updateChartingFavoriteFolder(input) {
    const payload = await postForm('/api/v1/stock-finder/favorite-folder/update', buildChartingFavoriteFolderPayload(input));

    return normalizeChartingMutationResult(payload, 'La carpeta de favoritos se ha actualizado.');
}

export async function deleteChartingFavoriteFolder(name) {
    const payload = await postForm('/api/v1/stock-finder/favorite-folder/delete', buildChartingFavoriteFolderPayload({ name }));

    return normalizeChartingMutationResult(payload, 'La carpeta de favoritos se ha eliminado.');
}

export async function addTickerToChartingFavorites(input) {
    const payload = await postForm('/api/v1/stock-finder/save/favorites', buildChartingFavoriteMembershipPayload(input));

    return normalizeChartingMutationResult(payload, 'El ticker se ha anadido a favoritos.');
}

export async function removeTickerFromChartingFavorites(input) {
    const payload = await postForm('/api/v1/stock-finder/delete/favorites', buildChartingFavoriteMembershipPayload(input));

    return normalizeChartingMutationResult(payload, 'El ticker se ha eliminado de favoritos.');
}
